import { Checkbox } from "@progress/kendo-react-inputs";
import React from "react";
import Images from "../../Assets/Images";

export class SingleDropDownCheckboxCommonFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
    };
  }

  componentDidMount() {
    this.init();
  }
  init = () => {
    let existingFilter = this.props.existingFilter
      ? this.props.existingFilter
      : [];
     let data= this.props.filterData?.map((item)=>{
        item["name"]=item.name;
        item["checked"]=this.checkCFinFilterValuesOrNot(this.props.column.field,item.name,existingFilter);
        return item;
      })
    this.setState({
      data: data,
      existingFilter: existingFilter,
    });
  };

  checkCFinFilterValuesOrNot = (field, value, exfilter) => {
    let flag = false;
    value=value===" [blank]"?null:value;
    try {
      if (exfilter) {
        exfilter.map((filter) => {
          if (filter.field === field && filter.value == value) {
            flag = true;
          }
          if (filter.filters) {
            filter.filters.map((innerFilter) => {
              if (innerFilter.field === field && innerFilter.value == value) {
                flag = true;
              }
            });
          }
        });
      }
    } catch (err) {
      return flag;
    }
    return flag;
  };

  filterValue = () => {
    let temparr = [];

    this.state.data.map((item) => {
      if (item.checked) {
        temparr.push(item.name);
      }
    });

    let filter = [];
    temparr.map((item) => {
      if (item === ""||item===" [blank]") {
        filter.push({
          field: this.props.column.field,
          operator: "eq",
          value: null,
        },{
          field: this.props.column.field,
          operator: "eq",
          value: "",
        });
      } else {
        filter.push({
          field: this.props.column.field,
          operator: "contains",
          value: item,
        });
      }
    });

    let temp = {
      logic: "or",
      filters: filter,
    };
    let col = this.props.column.field;

    this.props.filterChangeV(temp, col);
    this.props.onCloseMenu();
  };
  clearFilter = () => {
    try {
      let exi = [];
      if (this.props.existingFilter) {
        let filterData = this.props.existingFilter;
        filterData.map((filter2) => {
          if (filter2.filters) {
            filter2.filters.map((innerFilter) => {
              if (innerFilter.field != this.props.column.field) {
                if (!exi.includes(filter2)) {
                  exi.push(filter2);
                }
              }
            });
          } else {
            if (filter2.field != this.props.column.field) {
              if (!exi.includes(filter2)) {
                exi.push(filter2);
              }
            }
          }
        });
      }

      this.props.clearFilter(exi);
      this.props.onCloseMenu();

      this.state.data.map((item) => {
        item["checked"] = false;
      });
    } catch (err) {}
  };

  handleChange = (e, item) => {
    this.state.data.find((v) => v.name == item.name).checked = e.value;
  };
  render() {
    return (
      <div style={{ padding: 10 }}>
        <br />
        <span>
          <img src={Images.FILTERWHITE} width="12" alt="Filter" /> Filter
        </span>
        <div className="checkBoxWrapper">
          {this.state.data &&
            this.state.data.map((item, index) => (
              <div className="checkBoxCont">
                <Checkbox
                  label={item.name}
                  value={item.checked}
                  onChange={(e) => this.handleChange(e, item)}
                />
              </div>
            ))}
        </div>
        <br />
        <div className="filterBtnCont">
          <div className="btnBox">
            <button className="k-button" onClick={this.clearFilter}>
              Clear
            </button>
          </div>
          <div className="btnBox">
            <button className="k-button k-primary" onClick={this.filterValue}>
              Filter
            </button>
          </div>
        </div>
      </div>
    );
  }
}
